import Icon from '../components/Icon.vue'

Icon.register({"yen-sign":{"width":384,"height":512,"paths":[{"d":"M351.2 32H285.9A12-12 0 0 1 275.2 38.7L219.8 151.9C205.3 186.6 192.6 223.8 192.6 223.8H191.4S178.7 186.6 164.2 151.9L108.8 38.7A12-12 0 0 1 98.1 32H32.8C23.7 32 17.9 41.6 22.2 49.6L102.3 200H44C37.4 200 32 205.4 32 212V244C32 250.6 37.4 256 44 256H132.2L152 293.2V320H44C37.4 320 32 325.4 32 332V364C32 370.6 37.4 376 44 376H152V468C152 474.6 157.4 480 164 480H220C226.6 480 232 474.6 232 468V376H340C346.6 376 352 370.6 352 364V332C352 325.4 346.6 320 340 320H232V293.2L251.8 256H340C346.6 256 352 250.6 352 244V212C352 205.4 346.6 200 340 200H281.7L361.8 49.6C366.1 41.6 360.3 32 351.2 32z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/yen-sign.js
// module id = null
// module chunks = 